import { CustomAlertComponent } from '../../components/custom-alert/custom-alert.component';
import { Injectable } from '@angular/core';
import { UserDataService } from '../user-data/user-data.service';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { OpenModalGuardService } from '../open-modal-guard/open-modal-guard.service';
import { ModalController } from '@ionic/angular';
import { LoginPage } from './../../pages/login/login.page';
import { HelperService } from '../helper/helper.service';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {

  constructor(
    private modalController: ModalController,
    private openModalGuardService: OpenModalGuardService,
    private userDataService: UserDataService,
    private router: Router,
    private helperService: HelperService,
  ) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

    return this.userDataService.currentUserObservable
      .pipe(
        take(1),
        map((user: any) => {
          if (user && !user.emailVerified) {
            this.openVerifyEmail(user);
            return true;
          }
          if (user && user.isAnonymous) {
            return false;
          }
          return !!user; // lo mapea a booleano
        }),
        tap(logged => {
          if (!logged) {
            const deniedUrl = [];
            next.url.forEach((url, index) => {
              if (index === 0) {
                deniedUrl.push(`/${url.path}`);
              } else {
                deniedUrl.push(url.path);
              }
            });
            this.userDataService.saveUrlDeniedLogin(deniedUrl);
            this.router.navigate(['']).then(() => {
              this.openLoginAlert().then((data) => {
              });
            });
          }
        })
      );
  }

  async showLogin(login: boolean) {
    // indica que se debe bloquear/desbloquear la navegacion
    this.openModalGuardService.setModalOpen(true);
    // crea el modal con el mapa
    const loginModal = await this.modalController.create({
      component: LoginPage,
      componentProps: {
        actionMessage: 'message',
        openLogin: login,
      },
      backdropDismiss: false,
    });
    loginModal.onDidDismiss().then(data => {
      // indica que se debe bloquear/desbloquear la navegacion
      this.openModalGuardService.setModalOpen(false);
    });
    // presenta el modal con el login
    return await loginModal.present();
  }

  // modal para alerta de login o registro, no es el mismo de login, sino la alerta como tal
  async openLoginAlert() {
    // indica que se debe bloquear/desbloquear la navegacion
    this.openModalGuardService.setModalOpen(true);
    // crea el modal de alerta para logerse o registrarse
    const loginModalAlert = await this.modalController.create({
      component: CustomAlertComponent,
      cssClass: 'custom-alert-medium',
      componentProps: {
        icon: 'info-cuenta',
        title: `Bienvenido`,
        message : 'Registrate en la app para continuar o si ya tienes usuario inicia sesión',
        buttons: [
          {
            text: 'Ingresa',
            fill: 'solid',
            color: 'primary',
            action: 'login'
          },
          {
            text: 'Registrate',
            fill: 'solid',
            color: 'primary',
            action: 'register'
          },
        ]
      },
      backdropDismiss: false,
    });
    loginModalAlert.onDidDismiss().then(data => {
      this.openModalGuardService.setModalOpen(false);
      if (data.data.action === 'login') {
        this.showLogin(true);
      }
      if (data.data.action === 'register') {
        this.showLogin(false);
      }
    });
    // presenta el modal con la alerta de login
    return await loginModalAlert.present();
  }

  async openVerifyEmail(user: any) {
    this.router.navigate(['']);
    // indica que se debe bloquear/desbloquear la navegacion
    this.openModalGuardService.setModalOpen(true);
    // crea el modal de alerta para logerse o registrarse
    const loginModalAlert = await this.modalController.create({
      component: CustomAlertComponent,
      cssClass: 'custom-alert-medium',
      componentProps: {
        icon: 'correo-celeste',
        title: `Valida tu correo electrónico`,
        subtitle: 'Es necesario que valides tu correo electrónico para continuar.',
        message : '¿No has recibido ningún correo? reenvía el correo electrónico',
        buttons: [
          {
            text: 'Reenviar',
            fill: 'solid',
            color: 'primary',
            action: 'resend'
          },
          {
            text: 'Entendido',
            fill: 'solid',
            color: 'primary',
            action: 'understood'
          },
        ]
      },
      backdropDismiss: false,
    });
    loginModalAlert.onDidDismiss().then(data => {
      const settings = {
        url: environment.baseUrl
      };
      this.openModalGuardService.setModalOpen(false);
      if (data.data.action === 'resend') {
        user.sendEmailVerification(settings).then( () => {
          this.helperService.presentMessageAlert(
            'Mail reenviado',
            'Abre tu email y da clic en el enlace para validar tu cuenta',
            '',
            'confirmacion',
            'medium'
          );
        }, error => {
          this.helperService.presentMessageAlert(
            'Mensaje',
            error.message,
            '',
            'alerta',
            'medium'
          );
        });
      }
    });
    // presenta el modal con la alerta de login
    return await loginModalAlert.present();
  }
}
